
export async function sendMistakeAnswer( data ) {

  let url = '/api/mistakes/answer'
  console.log(data)
  return await $axios.post( url, data ).then( response => {
    console.log( response.data )
    return response.data
  }).catch( error => {
    console.log("error")
    console.log(error)
    return error
  })
}

export async function markMistakeAsLearned( mistakeId, data ) {

  let url = '/api/mistakes/' + mistakeId
  console.log(data)
  return await $axios.delete( url, data ).then( response => {
    console.log( response.data )
    return response.data
  }).catch( error => {
    console.log("error")
    console.log(error)
    return error
  })
}

//create new mistake
export async function createMistake( data ) {

  let url = '/api/mistakes'
  console.log(data)
  return await $axios.post( url, data ).then( response => {
    console.log( response.data )
    return response.data
  }).catch( error => {
    console.log("error")
    console.log(error)
    return error
  })
}